import { Box, BoxProps } from '@mui/material';

const VectorSettings = (props: BoxProps): JSX.Element => {
  return (
    <Box {...props}>
      <svg
        width="39"
        height="113"
        viewBox="0 0 39 113"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_7470_122610)">
          <path
            d="M6.99994 59.4985L8.46292 59.1673L6.99994 59.4985ZM22.6223 5.62283C22.4146 4.82086 21.5962 4.3391 20.7942 4.54679L7.72532 7.9313C6.92335 8.13899 6.4416 8.95748 6.64929 9.75945C6.85698 10.5614 7.67547 11.0432 8.47744 10.8355L20.0942 7.82704L23.1027 19.4438C23.3103 20.2458 24.1288 20.7275 24.9308 20.5198C25.7328 20.3122 26.2145 19.4937 26.0068 18.6917L22.6223 5.62283ZM33 106.999C34.0861 105.965 34.0863 105.965 34.0864 105.965C34.0863 105.965 34.0863 105.965 34.0862 105.965C34.0859 105.965 34.0853 105.964 34.0844 105.963C34.0827 105.961 34.0797 105.958 34.0755 105.954C34.0672 105.945 34.0542 105.931 34.0365 105.912C34.0011 105.874 33.9473 105.817 33.8761 105.74C33.7336 105.585 33.5215 105.353 33.248 105.046C32.701 104.434 31.9088 103.524 30.9375 102.349C28.9943 99.9967 26.3376 96.5835 23.495 92.3505C17.8 83.87 11.4063 72.1692 8.46292 59.1673L5.53695 59.8297C8.5929 73.3288 15.1992 85.3784 21.0044 94.023C23.9119 98.3526 26.6303 101.846 28.6248 104.259C29.6223 105.467 30.4395 106.405 31.0097 107.044C31.2948 107.363 31.5183 107.608 31.6717 107.774C31.7484 107.858 31.8076 107.921 31.8483 107.964C31.8687 107.986 31.8844 108.003 31.8953 108.014C31.9008 108.02 31.9051 108.025 31.9082 108.028C31.9097 108.03 31.911 108.031 31.9119 108.032C31.9124 108.032 31.9128 108.033 31.9131 108.033C31.9135 108.033 31.9138 108.034 33 106.999ZM8.46292 59.1673C6.16427 49.0135 9.54759 36.0093 13.6801 25.3204C15.7293 20.0201 17.929 15.3723 19.617 12.0491C20.4605 10.3884 21.175 9.06094 21.6773 8.15092C21.9284 7.69596 22.1264 7.34551 22.2608 7.1101C22.328 6.9924 22.3793 6.90348 22.4135 6.84465C22.4305 6.81523 22.4433 6.79333 22.4516 6.77913C22.4557 6.77203 22.4588 6.76686 22.4607 6.76362C22.4616 6.762 22.4623 6.76087 22.4627 6.76022C22.4629 6.7599 22.4629 6.75979 22.463 6.75962C22.463 6.75964 22.4629 6.75976 21.1702 5.99889C19.8775 5.23801 19.8773 5.23839 19.877 5.23889C19.8768 5.23921 19.8765 5.23984 19.8761 5.2405C19.8753 5.24182 19.8742 5.24363 19.8729 5.24592C19.8702 5.25052 19.8664 5.25707 19.8614 5.26555C19.8515 5.28251 19.8371 5.3072 19.8184 5.33945C19.781 5.40394 19.7263 5.49869 19.6557 5.62238C19.5144 5.86973 19.3093 6.23287 19.0508 6.70122C18.5339 7.63779 17.803 8.99576 16.9422 10.6904C15.2216 14.0779 12.9767 18.8204 10.8819 24.2386C6.72654 34.9867 3.0247 48.7323 5.53695 59.8297L8.46292 59.1673Z"
            fill="#1F1F1F"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_7470_122610"
            x="0.719238"
            y="0.498047"
            width="37.3672"
            height="111.535"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_7470_122610"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_7470_122610"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </Box>
  );
};

export default VectorSettings;
